var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/discord") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.3302818,1.55593154 C18.776719,0.829058124 17.115576,0.300796763 15.3788967,0 C15.1656116,0.385610725 14.9164335,0.904265539 14.7446343,1.31685355 C12.8984996,1.03921778 11.0693407,1.03921778 9.2571578,1.31685355 C9.08539144,0.904265539 8.83055476,0.385610725 8.61536154,0 C6.87680691,0.300796763 5.2137558,0.830999173 3.66019299,1.55978074 C0.526642796,6.29498569 -0.322811145,10.9125762 0.101916648,15.4645989 C2.18025186,17.0166483 4.19440909,17.9594716 6.17457495,18.576429 C6.66348894,17.9035431 7.09953404,17.1882502 7.47517633,16.4343995 C6.75975181,16.1625539 6.07452869,15.8270814 5.42707377,15.4376215 C5.59884014,15.3103677 5.766856,15.1773236 5.92918032,15.0404304 C9.87819471,16.8874863 14.1688995,16.8874863 18.0707366,15.0404304 C18.234969,15.1773236 18.402952,15.3103677 18.5728431,15.4376215 C17.9234801,15.8289896 17.2363816,16.1644621 16.5209571,16.4363405 C16.8965994,17.1882502 17.3307692,17.9054842 17.8215585,18.5783372 C19.8036325,17.9613798 21.8196584,17.0185893 23.8979953,15.4645989 C24.3963513,10.1876439 23.0466644,5.6124603 20.3302818,1.55593154 Z M8.01317583,12.6651459 C6.82772141,12.6651459 5.85555206,11.558452 5.85555206,10.210772 C5.85555206,8.86309193 6.80696206,7.75448988 8.01317583,7.75448988 C9.2194225,7.75448988 10.191559,8.86115088 10.1707996,10.210772 C10.1726748,11.558452 9.2194225,12.6651459 8.01317583,12.6651459 Z M15.986741,12.6651459 C14.8012866,12.6651459 13.8291173,11.558452 13.8291173,10.210772 C13.8291173,8.86309193 14.7804943,7.75448988 15.986741,7.75448988 C17.1929548,7.75448988 18.1651242,8.86115088 18.1443648,10.210772 C18.1443648,11.558452 17.1929548,12.6651459 15.986741,12.6651459 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/discord",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/primary",
    transform: "translate(-0.000000, 2.421663)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -2.421663)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.2161d180e7901eef68fcb156c049edc3.svg";
export { ForwardRef as ReactComponent };